// Central manifest of all feature flags and their safe defaults (opt-in by default).
// To add a new feature: add one line here, then override per hospital below as needed.
const featureDefaults = {
  bulkPatientUpload: false,
};

const hospitals = {
  borivali: {
    name: "Sunrise Oncology Center - Borivali",
    subName: "(Operated under SHREE SAISAMARTH HEALTHCARE PVT. LTD.)",
    address: "1st Floor, Sai Towers, Soda Wala Ln, Govind Nagar, Borivali West, Mumbai, 400092",
    phone1: "+912235757438",
    phone2: "+917400066780",
    website: "www.sunriseoncocare.com",
    email: "contact@sunriseoncocare.com",
    logo: "/img/sunrise oncology center.png",
    features: {
      bulkPatientUpload: true,
    },
  },
  vasai: {
    name: "Sunrise Oncology Centre",
    subName: "A Unit of Shree Saisamarth Healthcare Pvt. Ltd",
    address: "Cardinal Gracias Memorial Hospital Trust, Bangali, Sandor, P. O Vasai, Dist. Palghar, Maharashtra - 401201",
    phone1: "7400066780",
    phone2: "8655313403",
    website: "www.sunriseoncocare.com",
    email: "contact@sunriseoncocare.com",
    logo: "/img/sunrise oncology center.png",
  },
  gwalior: {
    name: "Cancer Hospital and Research Institute Gwalior M.P.",
    subName: "Regional Center of Cancer for Treatment & Research (Approved By - Government of India)",
    address: "Cancer Hills, Mandre Ki Mata Road, Gwalior - 474009 (M.P.)",
    phone1: "0751-2336502",
    phone2: "0751-2336505",
    website: "cancerhospitalgwalior.com",
    email: "support@cancerhospitalgwalior.com",
    logo: "/img/chri.png",
    features: {
      bulkPatientUpload: true,
    },
  },
};

// Map of login email → hospital key
const emailToHospital = {
  "ashayoncology@gmail.com": "borivali",
  "contact_vasai@sunriseoncocare.com": "vasai",
  "chri-doctor@gmail.com":"gwalior",
  "chri-assistant@gmail.com":"gwalior",
};

function getLoggedInEmail() {
  const candidates = [
    localStorage.getItem("username"),
    localStorage.getItem("userEmail"),
    localStorage.getItem("email"),
    localStorage.getItem("loginEmail"),
    sessionStorage.getItem("userEmail"),
    sessionStorage.getItem("email"),
  ];

  // Fallback: decode JWT sub claim
  try {
    const jwt = localStorage.getItem("jwttoken");
    if (jwt) {
      const payload = JSON.parse(atob(jwt.split(".")[1]));
      candidates.push(payload.sub, payload.email);
    }
  } catch (e) {}

  return candidates.find((e) => e && e.trim() !== "") || null;
}

function getHospitalDetails() {
  const email = getLoggedInEmail();
  const key = (email && emailToHospital[email]) || "borivali";
  return hospitals[key];
}

export function getHospitalHeaderHtml(hospital) {
  if (!hospital) return '';
  const contact = hospital.phone2 ? `${hospital.phone1} / ${hospital.phone2}` : hospital.phone1;
  const logoUrl = hospital.logo ? `${window.location.origin}${process.env.PUBLIC_URL || ''}${hospital.logo}` : '';
  return `
    <div class="hospital-header-row">
      ${logoUrl ? `<img src="${logoUrl}" alt="Hospital Logo" class="hospital-header-logo" />` : ''}
      <h2>${hospital.name}</h2>
    </div>
    ${hospital.subName ? `<p>${hospital.subName}</p>` : ''}
    ${hospital.address ? `<p>Address: ${hospital.address}</p>` : ''}
    ${contact ? `<p>Contact: ${contact}</p>` : ''}
    ${hospital.website ? `<p>website: ${hospital.website}</p>` : ''}
    ${hospital.email ? `<p>email: ${hospital.email}</p>` : ''}
  `;
}

export function getHospitalHeaderLines(hospital) {
  if (!hospital) return null;
  return {
    name: hospital.name,
    subName: hospital.subName || null,
    logoUrl: hospital.logo ? `${process.env.PUBLIC_URL || ''}${hospital.logo}` : null,
    addressLine: hospital.address ? `Address: ${hospital.address}` : null,
    contactLine: hospital.phone1
      ? `Contact: ${hospital.phone2 ? `${hospital.phone1} / ${hospital.phone2}` : hospital.phone1}`
      : null,
    websiteLine: hospital.website ? `website: ${hospital.website}` : null,
    emailLine: hospital.email ? `email: ${hospital.email}` : null,
  };
}

export function getHospitalFeatures() {
  const hospital = getHospitalDetails();
  return { ...featureDefaults, ...hospital.features };
}

export default getHospitalDetails;
